import { t } from 'i18next';
import * as yup from 'yup';

const countrySchema = yup.object().shape({
  name: yup.string().nullable(),
  abbreviation: yup.string().nullable(),
  id: yup.number().nullable(),
});

const stateSchema = yup.object().shape({
  name: yup.string().nullable(),
  abbreviation: yup.string().nullable(),
  id: yup.number().nullable(),
});

export const addressSchema = (isStateObject = false) =>
  yup.object().shape({
    line1: yup.string().trim().label(t('labelAddressLine1')).nullable().required(),
    line2: yup.string().trim().label(t('labelAddressLine2')).nullable(),
    country: countrySchema.label(t('labelCountry')).nullable().required(),
    state: isStateObject
      ? stateSchema.label(t('labelState')).nullable().required()
      : yup.string().trim().label(t('labelState')).nullable().required(),
    postalCode: yup.string().trim().label(t('labelPostalCode')).nullable().required(),
    city: yup.string().trim().label(t('labelCity')).nullable().required(),
    locationName: yup.string().trim().label(t('labelLocationName')).nullable().required(),
  });
